<template>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" width="500px" :append-to-body="true">
        <el-row class="set_border">
            <el-col :span="8">
                <div class="majTitle1">项目阶段</div>
            </el-col>
            <el-col :span="16">
                <div class="majTitle2"> {{ stepName }}</div>
            </el-col>
        </el-row>
        <el-row class="set_border">
            <el-col :span="8">
                <div class="majTitle1">类型名称</div>
            </el-col>
            <el-col :span="16">
                <div>
                    <!-- <div class="majTitle2" v-if="this.dataForm.systemFlg == '1'"> {{ dataForm.filekindName }}</div> -->
                    <div class="fkn" v-if="this.dataForm.systemFlg == '1'"> {{ dataForm.filekindName }}</div>
                    <el-input v-else class="sp-input1" v-model="dataForm.filekindName"></el-input>
                </div>
            </el-col>
        </el-row>
        <el-row class="set_border1">
            <el-col :span="8">
                <div class="subTitle">子类型列表</div>
            </el-col>
            <el-col :span="16" style="text-align: right;padding:5px 5px 0 0 ">
                <el-button v-preventReClick class="btn" type="primary" size="small" :disabled="updateFlg || addFlg"
                    @click="addSubClassHandle()"> 新增</el-button>
            </el-col>
        </el-row>
        <el-row style="margin-top: -1px;">
            <el-table ref="dataListTable" class="dataListTable" :data="dataForm.subList" header-align="center" border
                :cell-style="{ padding: '0px' }" header-cell-class-name="dataListTHeader" style="margin-bottom: 20px;">
                <el-table-column label="NO." type="index" width="80" align="center">
                    <!-- <template slot-scope="scope">
                        <span v-if="!getDisabled(scope.$index)">{{ scope.row.colSort }}</span>
                        <el-input class="sp-input" v-if="getDisabled(scope.$index)"
                            v-model="scope.row.colSort"></el-input>
                    </template> -->
                </el-table-column>
                <el-table-column label="类型名称" prop="subclassname" width="259" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="!getDisabled(scope.$index)">{{ scope.row.subclassname }}</span>
                        <el-input class="sp-input" v-if="getDisabled(scope.$index)"
                            v-model="scope.row.subclassname"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button v-preventReClick type="text" size="small" class="min_btn"
                            v-if="!updateFlg && !addFlg && scope.row.systemFlg == '0'"
                            @click="updateSubClassHandle(scope.$index, scope.row)">修改</el-button>
                        <el-button v-preventReClick type="text" size="small" class="min_btn"
                            v-if="!updateFlg && !addFlg && scope.row.systemFlg == '0'"
                            @click="deleteHandle(scope.$index)">删除</el-button>
                        <!--新增时按钮-->
                        <el-button v-preventReClick type="text" size="small" @click="saveHandle()"
                            v-if="getDisabled(scope.$index) && addFlg">保存</el-button>
                        <el-button v-preventReClick type="text" size="small" @click="cancelSaveHandle()"
                            v-if="getDisabled(scope.$index) && addFlg">取消</el-button>
                        <!--修改时按钮-->
                        <el-button v-preventReClick type="text" size="small" @click="updateHandle()"
                            v-if="getDisabled(scope.$index) && updateFlg">保存</el-button>
                        <el-button v-preventReClick type="text" size="small" @click="cancelUpdateHandle()"
                            v-if="getDisabled(scope.$index) && updateFlg">取消</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row style="margin-top: 10px;text-align: center;">
            <el-col :span="24">
                <el-button v-preventReClick class="btn" type="primary" size="small"
                    :disabled="updateFlg || addFlg || this.dataForm.subList == undefined || this.dataForm.subList.length == 0"
                    @click="dataFormSubmit()">保存</el-button>
            </el-col>
        </el-row>

        <el-row class="formBtnGroup">
        </el-row>
    </el-dialog>
</template>

<script>

import $common from "@/utils/common.js"
export default {
    data() {
        return {
            visible: false,
            inline: false,
            subjectTypeList: [],
            dataForm: {
                stepCode: '',
                filekindcode: '',
                filekindName: '',
                systemFlg: '',
                subList: [
                ]
            },
            type: '',
            stepName: '',
            updateIndex: '',
            updateFlg: false,
            addIndex: '',
            addFlg: false,
            title: '',
            dataRule: {
                filekindName: [
                    { required: true, message: "类型不能为空", trigger: "blur" }
                ],
            },
            updateData: {
                colSort: 0,
                subclassname: '',
            }
        }
    },
    computed: {
    },
    methods: {
        getDisabled(index) {
            if (this.addIndex === '' && this.updateIndex === '') {
                return false;
            } else if (this.addIndex === index && this.addIndex !== '') {
                return true;
            } else if (this.updateIndex === index && this.updateIndex !== '') {
                return true;
            } else {
                return false;
            }
        },
        init(stepCode, filekindcode, type) {
            console.log("init type", type)
            this.dataForm = {
                stepCode: stepCode,
                filekindcode: '',
                filekindName: '',
                systemFlg: '0',
                subList: [
                ]
            }
            if (stepCode == '01') {
                this.stepName = '前期准备阶段'
            } else if (stepCode == '02') {
                this.stepName = '建造开工准备期阶段'
            } else if (stepCode == '03') {
                this.stepName = '建造期阶段'
            } else if (stepCode == '04') {
                this.stepName = '交船验收期阶段'
            } else if (stepCode == '05') {
                this.stepName = '质保期阶段'
            }
            this.dataForm.filekindcode = filekindcode
            this.dataForm.workNo = $common.getItem("workNo");
            this.visible = true;
            this.addIndex = ''
            this.updateIndex = ''
            this.updateFlg = false
            this.addFlg = false
            this.type = type
            // 修改
            this.title = '新增文件类型'
            if (type == 1) {
                this.title = '调整文件类型'
                this.getInfo()
            }
            // this.$nextTick(() => {
            //     this.$refs["dataForm"].resetFields()
            // })
        },
        getInfo() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/projectfilekind/getInfo",
                method: "get",
                params: this.$http.adornParams({
                    filekindcode: this.dataForm.filekindcode,
                    workNo: $common.getItem("workNo"),
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.dataForm = data.body
                }
            });
        },
        updateSubClassHandle(index, subClass) {
            this.updateFlg = true;
            this.updateIndex = index;
            this.updateData = {
                colSort: subClass.colSort,
                subclassname: subClass.subclassname,
            }
        },
        saveHandle() {
            this.addFlg = false;
            this.addIndex = '';
        },
        cancelSaveHandle() {
            let subList = [];
            for (var i = 0; i < this.dataForm.subList.length; i++) {
                if (i != this.addIndex) {
                    subList.push(this.dataForm.subList[i]);
                }
            }
            this.dataForm.subList = subList;
            this.addFlg = false;
            this.addIndex = '';
        },
        updateHandle() {
            this.updateFlg = false;
            this.updateIndex = '';
        },
        cancelUpdateHandle() {
            for (var i = 0; i < this.dataForm.subList.length; i++) {
                if (i == this.updateIndex) {
                    this.dataForm.subList[i].colSort = this.updateData.colSort
                    this.dataForm.subList[i].subclassname = this.updateData.subclassname
                }
            }
            this.updateFlg = false;
            this.updateIndex = '';
        },
        addSubClassHandle() {
            let subList = this.dataForm.subList;
            let maxSort = 1;
            if (subList != undefined && subList.length > 0) {
                for (var i = 0; i < subList.length; i++) {
                    if (maxSort < parseInt(subList[i].colSort)) {
                        maxSort = parseInt(subList[i].colSort);
                    }
                }
                maxSort = maxSort + 1;
            }
            let sub = {
                colName: '',
                subclasscode: '',
                subclassname: '',
                systemFlg: '0',
                colSort: maxSort,
            }
            this.dataForm.subList.push(sub);
            this.addFlg = true;
            this.addIndex = this.dataForm.subList.length - 1
        },
        deleteHandle(index) {
            this.dataForm.subList.splice(index, 1);
        },
        dataFormSubmit() {
            if (this.dataForm.filekindName == '' || this.dataForm.filekindName == undefined) {
                this.$message.error("请填写类型名称！")
                return
            }

            const subclassNames = new Set();
            for (var i = 0; i < this.dataForm.subList.length; i++) {
                const item = this.dataForm.subList[i];
                // 先校验为空的情况（保留原有逻辑）
                if (item.subclassname === '') {
                    this.$message.error(`第${i + 1}子类型名称数据为空！`);
                    return;
                }
                // 校验重复值
                if (subclassNames.has(item.subclassname)) {
                    this.$message.error(`类型名称‘${item.subclassname}’重复！`);
                    return;
                }
                // 将当前值加入集合
                subclassNames.add(item.subclassname);
            }



            let _url = "/business/projectfilekind/save";
            if (this.type == 1) {
                _url = "/business/projectfilekind/update";
            }
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData(this.dataForm)
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                            this.$emit("refreshDataList");
                        }
                    });
                }
            });
        }
    }
}
</script>
<style scoped>
.sp-input /deep/ .el-input__inner {
    width: 100% !important;
}

::v-deep .el-form-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 0px !important;
}

.item::v-deep .el-form-item__label {
    color: #00428e !important;
    margin-right: 10px !important;
    font-weight: bold !important;
    background-color: rgb(211, 230, 248);
    white-space: nowrap !important;
    text-align: center !important;
}

.set_border {
    border: solid #dadada 1px;
    border-bottom: 0px solid #adadad;
}

.set_border1 {
    border: solid #dadada 1px;
}

.sp-input1 {
    margin-top: 2px;
    width: 240px !important;
    margin-left: 5px;
}

.majTitle1 {
    background-color: #E1F1FF;
    padding-left: 25px;
    font-weight: bolder;
    color: #00428e !important;
    height: 45px;
    padding-top: 14px;
    border-right: solid #dadada 1px;
}

.majTitle2 {
    background-color: #E1F1FF;
    padding-left: 25px;
    font-weight: bolder;
    color: #00428e !important;
    height: 45px;
    padding-top: 15px;
}

.majTitle3 {
    padding-left: 15px;
    font-weight: bolder;
    color: #00428e !important;
    height: 45px;
    border-left: 0px;
}

.subTitle {
    padding-left: 25px;
    font-weight: bolder;
    color: #00428e !important;
    height: 45px;
    padding-top: 14px;
}

.fkn {
    padding-left: 25px;
    font-weight: bolder;
    height: 45px;
    padding-top: 15px;
}
</style>
